import React from 'react';
import { validationClasses } from '@/utils/errors';
import fieldConstants from '@/constants/fields';
import DictionaryFieldDropdown from '@/datasets/fields/components/DictionaryFieldDropdown';
import QueryFilterContainer from './QueryFilterContainer';
import { cohortFilterWidths } from '../constants';
import { filterableFields } from '../../helper';

const QueryFilterFieldEditCell = ({
  fields,
  fieldName,
  exists,
  canRead,
  canEdit,
  onChange,
  queryUUID,
  saveErrors,
  filterUUID,
  fieldBeforeEdit,
}) => {
  const validationError = (saveErrors || []).find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fieldConstants.FIELD)));

  const filterFields = (allFields, selectedField) => {
    const filteredFields = filterableFields(allFields);
    if (selectedField) {
      const selectedFieldPresent = filteredFields.find((f) => f.name === selectedField.name);
      if (!selectedFieldPresent) {
        filteredFields.push({ ...selectedField, disabled: true });
      }
    }
    return filteredFields;
  };

  return (
    <QueryFilterContainer
      exists={exists}
      canRead={canRead}
      canEdit={canEdit}
      queryUUID={queryUUID}
      width={cohortFilterWidths.FIELD}
    >
      <DictionaryFieldDropdown
        className={validationClasses(validationError, 'aridhia-query-filter-field-edit-cell')}
        fields={filterFields(fields, fieldBeforeEdit)}
        onChange={onChange}
        fieldIdentifier={fieldName}
        byName
        message="table.filter.by.type.placeholder"
        searchable
      />
    </QueryFilterContainer>
  );
};

export default QueryFilterFieldEditCell;
